// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-link-wrapper
import Link from 'next/link'

import { Spacer } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { Description } from '../../ProductHighlights/styles'
import { UnderlinedLink } from '../styles'

const giftCardTermsLinkTo = '/pages/gift-card-terms'
const helpCenterHref = 'https://help.wearfigs.com'

export const GiftLinks = () => {
  const { giftCard: strings } = useTranslation()
  return (
    <>
      <Spacer height={16} />
      <Description>
        {strings.anyQuestions}{' '}
        <Link href={helpCenterHref}>
          <UnderlinedLink>{strings.helpCenter}</UnderlinedLink>
        </Link>
      </Description>
      <Spacer height={16} />
      <Description>
        {strings.seeOurTOCs}{' '}
        <Link href={giftCardTermsLinkTo}>
          <UnderlinedLink>{strings.here}</UnderlinedLink>
        </Link>
      </Description>
    </>
  )
}
